import { useLazyQuery, useQuery } from "@apollo/client";
import { CUSTOMER_TASKS } from "../customer-task.queries";
import {
  CustomerTasksQuery,
  CustomerTasksQueryVariables,
} from "../../../__generated__/CustomerTasksQuery";

export const useCustomerTasks = (variables: CustomerTasksQueryVariables) => {
  return useQuery<CustomerTasksQuery, CustomerTasksQueryVariables>(CUSTOMER_TASKS, {
    variables,
  });
};

export const useLazyCustomerTasks = () => {
  return useLazyQuery<CustomerTasksQuery, CustomerTasksQueryVariables>(CUSTOMER_TASKS);
};
